/**
 * @file 文章服務 API (前台)
 * @description 提供前台文章相關的 API 方法，包含文章列表、文章詳情等功能
 */
import { post } from './sub_services/base';
import apiPath from './api.path';
import config from 'config/config';
import ExceptionHandleService from 'utils/exceptionHandler';

const _EHS = new ExceptionHandleService({
  _NAME: 'services/posts.ts',
  _NOTICE: 'posts api'
});

/** 取得文章列表請求參數介面 */
export interface GetPostListParams {
  page?: number;
  pageSize?: number;
  [key: string]: unknown;
}

/** 取得指定文章請求參數介面 */
export interface GetPostByIdParams {
  postId: string;
  [key: string]: unknown;
}

/** [POST]取得文章列表 */
const getPostList = async (params: GetPostListParams): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.posts.getPostList}`;
    const result = await post(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'getPostList', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

/** [POST]取得指定文章 */
const getPostById = async (params: GetPostByIdParams): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.posts.getPostById}`;
    const result = await post(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'getPostById', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

export default {
  getPostList,
  getPostById
};
